import { useMemo } from 'react';
import { useTranslation } from '@eon/i18n';
import type { PaginationProps } from '@eon/ui';

/**
 * Returns the localised label bag expected by `<Pagination />`.
 * Stable across renders for the same language so it does not retrigger memoised
 * children unnecessarily.
 */
export function usePaginationLabels(): NonNullable<PaginationProps['labels']> {
  const { t, i18n } = useTranslation();
  return useMemo(
    () => ({
      first: t('pagination.first'),
      previous: t('pagination.previous'),
      next: t('pagination.next'),
      last: t('pagination.last'),
      page: t('pagination.page'),
      of: t('pagination.of'),
      rowsPerPage: t('pagination.rowsPerPage'),
      showing: (from: number, to: number, total: number) =>
        t('pagination.showing', { from, to, total }),
    }),
    // re-resolve when language changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n.language],
  );
}
